module.exports = __webpack_public_path__ + "static/img/news_bg.dd8313a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news_bg.png
// module id = 2LUF
// module chunks = 1